import React, { useState, useEffect } from 'react'
import Axios from 'axios'
import { Host } from '../App';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import './Attendance.css';
import Attendance_dashboard from './Attendance_dashboard';
import Vaccation from './Vaccation';
import { Link } from 'react-router-dom';
import { Redirect } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { FaCalendarAlt, FaUsers, FaClipboardList, FaChartBar, FaSun, FaMoon, FaToolbox, FaCouch, FaUserTie, FaChevronRight, FaPaperPlane, FaPrint } from 'react-icons/fa';

function Attendance() {
  const history = useHistory();
  const [selectedShift, setSelectedShift] = useState("");
  const [shiftSelection, setshiftSelection] = useState(false);
  const [rank, setrank] = useState(false);
  var Ranked = (window.localStorage.getItem("Rank"));
  var token = (window.localStorage.getItem("acessToken"));
  var user = (window.localStorage.getItem("Name"));
  const [employees, setemployees] = useState([]);
  const [leave_type, setleave_type] = useState([]);
  var [selectedLeaveType, setSelectedLeaveType] = useState('');
  const [Attendance_dashboard_sec, setAttendance_dashboard_sec] = useState(true);
  const [attendanceList, setAttendanceList] = useState([]);
  const [shift, setshift] = useState({});
  const [Date1, setDate1] = useState(new Date());
  const [Today, setToday] = useState(Date1.toISOString().slice(0, 10));
  const [Vaccation_sec, setvaccation_sec] = useState(false);
  const [redirect, setRedirect] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getShiftIcon = (shift) => {
    switch (shift) {
      case 'Morning_Operators': return <FaSun className="shift-icon" />;
      case 'Night_Operators': return <FaMoon className="shift-icon" />;
      case 'Woodshop': return <FaToolbox className="shift-icon" />;
      case 'Upholstery': return <FaCouch className="shift-icon" />;
      case 'Management': return <FaUserTie className="shift-icon" />;
      default: return <FaUsers className="shift-icon" />;
    }
  };

  const handleShiftChange = (event) => {
    setSelectedShift(event.target.value);
    setshift(event.target.value);
    setvaccation_sec(false);
    setshiftSelection(true);
    setAttendance_dashboard_sec(false);
  };

  const queryParams = {
    shift: shift,
    token: token,
    Rank: Ranked,
    Date: Today,
    user: user
  };

  //for today's date
  useEffect(() => {
    var timer = setInterval(() => setDate1(new Date()), 10)
    return function cleanup() {
      clearInterval(timer)
    }
  }, []);

  useEffect(() => {
    if (Ranked === '"Admin"') {
      setrank(true);
    }
  }, [Ranked]);

  useEffect(() => {
    if (shift.length > 1) {
      Axios.get(`https://` + Host + `/api/employees`, { params: queryParams })
        .then((data) => {
          const filteredEmployees = data.data.filter((employee) => employee.Name && employee.Name.length > 1);
          const initialAttendanceList = filteredEmployees.map((employee) => ({
            Date: Today,
            id: employee.Emp_ID,
            Employee_Name: employee.Name,
            Department: selectedShift,
            Status: 'present',
            LeaveType: '',
            Details: '',
            user: user
          }));
          setemployees(filteredEmployees);
          setAttendanceList(initialAttendanceList);
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
        });
    }
  }, [shift, Today]);

  useEffect(() => {
    Axios.get(`https://` + Host + `/api/leave_type`, { params: queryParams }).then((data) => {
      setleave_type(data.data);
    });
  }, [shift]);

  const handleRadioChange = (id, type) => {
    setAttendanceList((prevList) =>
      prevList.map((item) =>
        item.id === id
          ? {
            ...item,
            Status: type,
            Details: type === 'absent' ? '' : item.Details,
          }
          : item
      )
    );
  };

  const handleLeaveTypeChange = (id, value) => {
    if (value === "Vacation" || value === "Bereavement Leave") {
      setAttendanceList((prevList) =>
        prevList.map((item) =>
          item.id === id ? { ...item, LeaveType: value, Status: "" } : item
        )
      );
    }
    setAttendanceList((prevList) =>
      prevList.map((item) =>
        item.id === id ? { ...item, LeaveType: value } : item
      )
    );
  };

  const handleDetailsChange = (id, value) => {
    setAttendanceList((prevList) =>
      prevList.map((item) =>
        item.id === id ? { ...item, Details: value } : item
      )
    );
  };

  const vac = () => {
    setvaccation_sec(!Vaccation_sec);
    setshiftSelection(false);
    setAttendance_dashboard_sec(false);
  }

  const handleSubmit_trial = () => {
    Axios.post(`https://` + Host + `/api/addattendance`, {
      attendanceList
    }).then((response) => {
      if (response.status === 200) {
        toast.success(response.data.message, {
          autoClose: 3000,
          position: toast.POSITION.TOP_RIGHT,
          style: { fontSize: '24px', borderRadius: '10px' },
        });
        setTimeout(function () {
          history.push("/attendanceDetails");
        }, 3000);
      }
      if (response.status === 500) {
        toast.success(response.data.message, {
          autoClose: 3000,
          position: toast.POSITION.TOP_RIGHT,
          style: { fontSize: '24px', borderRadius: '10px' },
        });
        setTimeout(function () {
          window.location.reload();
        }, 3000);
      }
    })
  };

  const handleSubmit = () => {
    setIsLoading(true);
    Axios.post(`https://` + Host + `/api/addattendance`, {
      attendanceList, token: token
    }).then((response) => {
      if (response.status === 200) {
        window.alert(response.data.message);
        setIsLoading(false);
        setSelectedShift("");
        setAttendance_dashboard_sec(true);
      }
    })
      .catch(error => {
        window.alert("Data already exists")
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (redirect) {
      return <Redirect to="/attendance" />;
    }
  }, [redirect]);

  useEffect(() => {
    section_selected(selectedShift);
  }, [selectedShift]);

  const section_selected = (shiftType) => {
    switch (shiftType) {
      case 'Morning_Operators':
        setSelectedLeaveType('Morning Shift');
        break;
      case 'Night_Operators':
        setSelectedLeaveType('Night Shift');
        break;
      case 'Woodshop':
        setSelectedLeaveType('Woodshop');
        break;
      case 'Upholstery':
        setSelectedLeaveType('Upholstery');
        break;
      case 'Management':
        setSelectedLeaveType('Management');
        break;
      default:
        setSelectedLeaveType('');
        break;
    }
  };

  const print = () => {
    console.log(attendanceList);
  }

  return (
    <div className="attendance-container">
      <div className="attendance-header">
        <div className="header-content">
          <h1><FaUsers /> ATTENDANCE PORTAL</h1>

        </div>
        {selectedLeaveType && (
          <div className="shift-banner">
            <div className="shift-icon-container">
              {getShiftIcon(selectedShift)}
            </div>
            <div className="shift-info">
              <h2>{selectedLeaveType}</h2>
              <p className="shift-date">
                <FaCalendarAlt /> {new Date(Today).toLocaleDateString('en-US', {
                  weekday: 'long',
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </p>
            </div>
            <div className="shift-stats">
              <span className="stat">
                <span className="stat-number">{attendanceList.filter(a => a.Status === 'present').length}</span>
                <span className="stat-label">Present</span>
              </span>
              <span className="stat">
                <span className="stat-number">{attendanceList.filter(a => a.Status === 'absent').length}</span>
                <span className="stat-label">Absent</span>
              </span>
              <span className="stat">
                <span className="stat-number">{attendanceList.length}</span>
                <span className="stat-label">Total</span>
              </span>
            </div>
          </div>
        )}
      </div>

      <div className="control-panel">
        <div className="control-filters">
          <div className="filter-group">
            <div className="filter-icon">
              <FaUsers />
            </div>
            <select
              name="shift"
              className="form-control shift-select"
              value={selectedShift}
              onChange={handleShiftChange}
            >
              <option value="">Select Department/Shift</option>
              <option value="Morning_Operators"><FaSun /> 1st Shift (Morning)</option>
              <option value="Night_Operators"><FaMoon /> 2nd Shift (Night)</option>
              <option value="Woodshop"><FaToolbox /> Woodshop</option>
              <option value="Upholstery"><FaCouch /> Upholstery</option>
              {rank && <option value="Management"><FaUserTie /> Management</option>}
            </select>
          </div>

          <div className="filter-group">
            <div className="filter-icon">
              <FaCalendarAlt />
            </div>
            <input
              type='date'
              className="form-control date-input"
              defaultValue={Date1.toISOString().slice(0, 10)}
              onChange={(e) => setToday(e.target.value)}
            />
          </div>
        </div>

        <div className="control-buttons">
          <div className="button-grid">
            <Link to="/attendanceDetails" className="control-btn">
              <FaClipboardList />
              <span>Attendance Details</span>
            </Link>

            <Link to="/addpartdataset" className="control-btn">
              <FaUsers />
              <span>Employees</span>
            </Link>

            <Link to='/attendancereport' className="control-btn">
              <FaChartBar />
              <span>Attendance Report</span>
            </Link>

            <button className="control-btn vacation-btn" onClick={vac}>
              <FaSun />
              <span>Vacation Portal</span>
            </button>
          </div>
        </div>
      </div>

      {Attendance_dashboard_sec && !shiftSelection && !Vaccation_sec && <Attendance_dashboard />}
      {Vaccation_sec && <Vaccation />}

      {shiftSelection && (
        <div className="attendance-table-container">
          <div className="table-header">
            <h3>Mark Attendance for {selectedLeaveType}</h3>
            <div className="table-actions">
              <button className="btn-submit" onClick={handleSubmit} disabled={isLoading}>
                <FaPaperPlane />
                {isLoading ? 'Submitting...' : 'Submit Attendance'}
              </button>
              <button className="btn-print" onClick={print}>
                <FaPrint />
                Print Preview
              </button>
            </div>
          </div>

          <div className="table-wrapper">
            <table className="attendance-table">
              <thead>
                <tr>
                  <th className="employee-col">Employee Name</th>
                  <th className="status-col">Status</th>
                  <th className="reason-col">Leave Reason</th>
                  <th className="details-col">Details</th>
                </tr>
              </thead>
              <tbody>
                {attendanceList.map((item) => (
                  <tr key={item.id} className="attendance-row">
                    <td className="employee-name">
                      <div className="employee-info">
                        <div className="avatar">
                          {item.Employee_Name.charAt(0)}
                        </div>
                        <span>{item.Employee_Name}</span>
                      </div>
                    </td>
                    <td className="status-cell">
                      <div className="status-options">
                        <label className={`status-option ${item.Status === 'present' ? 'selected' : ''}`}>
                          <input
                            type="radio"
                            checked={item.Status === 'present'}
                            name={`Status_${item.id}`}
                            onChange={() => handleRadioChange(item.id, 'present')}
                            className="status-radio"
                          />
                          <span className="status-indicator present"></span>
                          <span className="status-text">Present</span>
                        </label>
                        <label className={`status-option ${item.Status === 'absent' ? 'selected' : ''}`}>
                          <input
                            type="radio"
                            checked={item.Status === 'absent'}
                            name={`Status_${item.id}`}
                            onChange={() => handleRadioChange(item.id, 'absent')}
                            className="status-radio"
                          />
                          <span className="status-indicator absent"></span>
                          <span className="status-text">Absent</span>
                        </label>
                      </div>
                    </td>
                    <td className="reason-cell">
                      {item.Status === 'absent' && (
                        <select
                          className="reason-select"
                          value={item.LeaveType || ''}
                          onChange={(e) => handleLeaveTypeChange(item.id, e.target.value)}
                        >
                          <option value="">Select Reason</option>
                          {leave_type.map((x) => (
                            <option key={x.type} value={x.type}>{x.type}</option>
                          ))}
                        </select>
                      )}
                      {item.Status === 'present' && (
                        <select
                          className="reason-select"
                          value={item.LeaveType || ''}
                          onChange={(e) => handleLeaveTypeChange(item.id, e.target.value)}
                        >
                          <option value="">Select Present Status</option>
                          {leave_type.map((x) => (
                            <option key={x.Present} value={x.Present}>{x.Present}</option>
                          ))}
                        </select>
                      )}
                      {item.Status === '' && (
                        <input type='text' className="reason-input" value={item.LeaveType} readOnly />
                      )}
                    </td>
                    <td className="details-cell">
                      <input
                        type='text'
                        className="details-input"
                        placeholder='Additional details...'
                        value={item.Details || ''}
                        onChange={(e) => handleDetailsChange(item.id, e.target.value)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>Submitting Attendance...</p>
          </div>
        </div>
      )}

      <ToastContainer />
    </div>
  )
}

export default Attendance